import React from 'react'
import styled, { css } from 'styled-components'
import { breakpoint, size } from '../layout/styles'
import { Container } from '../styles/Container'
import CommonSlider from './CommonSlider'
import ReactHtmlParser from 'react-html-parser'

const TimelineSection = ({ data, translations }: any) => {
  // Map the size object to an object with numeric values
  const numericSizes = Object.fromEntries(
    Object.entries(size).map(([key, value]) => [key, parseInt(value, 10)])
  );

  const swiperBreakpoints = {
    [numericSizes.mobile]: { slidesPerView: 1 },
    [numericSizes.phablet]: { slidesPerView: 2 },
    [numericSizes.tablet]: { slidesPerView: 3 },
    [numericSizes.desktop]: { slidesPerView: 4 },
  };

  return <Wrapper>
    {data.section_heading && <h2>
      {data.section_heading}
    </h2>}
    {data.section_content &&
      <Content dangerouslySetInnerHTML={{ __html: data.section_content }} />}
    {data.events?.length > 0 &&
      <EventsSlider
        items={data.events}
        slidesPerView={4}
        breakpoints={swiperBreakpoints}
        itemBuilder={(item: any) => (
          <TimelineWrapper>
            <TimelineDate>{item.timeline_date_year}</TimelineDate>
            <TimelineImage background={item.timeline_image?.url} />
            <TimelineCopy>{ReactHtmlParser(item.timeline_copy)}</TimelineCopy>
          </TimelineWrapper>
        )} />
    }
  </Wrapper>
}

const Wrapper = styled(Container)`
  margin: 36px 20px;
  color: var(--text);
  @media ${breakpoint.desktop} {
    margin: 0 auto 72px;
  }
`

const Content = styled.div<any>`
  width: 100%;
  margin-bottom: 32px;
`

const TimelineWrapper = styled.div<any>`
  position: relative;
  display: flex;
  flex-direction: column;
`

const TimelineDate = styled.div<any>`
  font-size: 19px;
  line-height: 1.57895;
  position: absolute;
  top: 8px;
  left: 14px;
  z-index: 1;
  padding: 0 12px;
  border: 2px solid;
  border-radius: 14px;
`

const TimelineImage = styled.div<any>`
  ${(props) =>
    props.background &&
    css`
      background-image: url('${props.background}?width=${1440}&auto=webp&format=pjpg&quality=75');
    `}
  flex: 1 1 50%;
  min-height: 201px;
  background-repeat: no-repeat;
  background-size: cover;
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: cover;
  mask-size: contain;
`

const EventsSlider = styled(CommonSlider)`
  .swiper-slide {
    &:nth-child(4n) {
      background: #2a007c;
      ${TimelineWrapper} {
        color: #00ffc6;
      }
      ${TimelineDate} {
        background: #2a007c;
      }
    }
    &:nth-child(4n+1) {
      background: #4f80ff;

      ${TimelineWrapper} {
        color: white;
      }
      ${TimelineDate} {
        background: #4f80ff;
      }
    }
    &:nth-child(4n+2) {
      background: #00ffc6;
      ${TimelineDate} {
        background: #00ffc6;
      }
    }
    &:nth-child(4n+3) {
      background: #ff715b;
      ${TimelineDate} {
        background: #ff715b;
      }
    }
    @media ${breakpoint.phablet} {
      &:nth-child(even) {
        ${TimelineWrapper} {
          display: flex;
          flex-direction: column-reverse;
        }
        ${TimelineImage} {
          background-position: center top;
          mask-image: url('/images/timeline-card-mask-bottom.svg');
          mask-position: left top;
        }
      }
      &:nth-child(odd) {
        ${TimelineImage} {
          background-position: center bottom;
          mask-image: url('/images/timeline-card-mask-top.svg');
          mask-position: right bottom;
        }
      }
    }
  }
`

const TimelineCopy = styled.div<any>`
  flex: 1 1 50%;
  min-height: 201px;
  font-size: 12.6px;
  line-height: 1.90476;
  padding: 40px 16px 8px;
  line-height: 1.3;
`

export default TimelineSection
